<template>
  <div class="action-section">
    <div class="action-header" @click="toggleSection">
      <i
        :class="[
          'mdi',
          isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right',
        ]"
      ></i>
      <span>Рішення до тікету</span>
      <button class="action-menu-btn">
        <i class="mdi mdi-dots-horizontal"></i>
      </button>
    </div>
    <div v-if="isExpanded" class="action-content">
      <div v-if="ticket.decidedComment" class="solution-info">
        <div
          v-if="ticket.decidedStatus"
          class="solution-status"
        >
          <span class="status-badge">{{
            ticket.decidedStatus
          }}</span>
        </div>
        <div class="solution-text">
          {{ ticket.decidedComment }}
        </div>
        <div
          v-if="
            ticket.decidedDatetime || ticket.problemWas !== null
          "
          class="solution-details"
        >
          <div v-if="ticket.decidedDatetime" class="detail-row">
            <i class="mdi mdi-calendar-clock"></i>
            <div>
              <label>Дата рішення</label>
              <p>{{ ticket.decidedDatetime }}</p>
            </div>
          </div>
          <div
            v-if="
              ticket.problemWas !== null &&
              ticket.problemWas !== undefined
            "
            class="detail-row"
          >
            <i class="mdi mdi-history"></i>
            <div>
              <label>Чи була проблема раніше</label>
              <p>{{ ticket.problemWas ? "Так" : "Ні" }}</p>
            </div>
          </div>
        </div>
        <button
          v-if="
            ticket.problemIn || ticket.passedTest !== null
          "
          @click="$emit('show-details')"
          class="details-btn"
        >
          <i class="mdi mdi-information-outline"></i>
          Деталі рішення
        </button>
      </div>
      <div v-else class="no-solution">
        <i class="mdi mdi-information-outline"></i>
        <p>Рішення ще не додано</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionSection",
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggle", "show-details"],
  data() {
    return {
      isExpanded: this.expanded,
    };
  },
  watch: {
    expanded(newVal) {
      this.isExpanded = newVal;
    },
  },
  methods: {
    toggleSection() {
      this.isExpanded = !this.isExpanded;
      this.$emit("toggle", this.isExpanded);
    },
  },
};
</script>

<style scoped>
.action-section {
  margin-bottom: 16px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: white;
}

.action-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
  position: relative;
}

.action-header i:first-child {
  font-size: 16px;
}

.action-header span {
  flex: 1;
}

.action-menu-btn {
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.action-menu-btn:hover {
  background: #f8f9fa;
}

.action-content {
  padding: 12px;
  border-top: 1px solid #e9ecef;
}

.solution-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.solution-status {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.solution-status .status-badge {
  padding: 6px 12px;
  background: #e8f5e9;
  color: #34c759;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.solution-text {
  font-size: 13px;
  line-height: 1.6;
  color: #212529;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #34c759;
}

.solution-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
}

.detail-row i {
  font-size: 18px;
  color: #6c757d;
  flex-shrink: 0;
  margin-top: 2px;
}

.detail-row label {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 2px;
  font-weight: 500;
}

.detail-row p {
  margin: 0;
  font-size: 12px;
  color: #212529;
  font-weight: 500;
}

.no-solution {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #adb5bd;
  text-align: center;
}

.no-solution i {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.no-solution p {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
}

.details-btn {
  width: 100%;
  margin-top: 12px;
  padding: 8px 12px;
  background: #007aff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s;
}

.details-btn:hover {
  background: #0051d5;
  transform: translateY(-1px);
}

.details-btn i {
  font-size: 16px;
}

@media (max-width: 768px) {
  .action-section {
    margin-bottom: 12px;
  }

  .action-header {
    padding: 10px;
    font-size: 12px;
  }

  .action-content {
    padding: 10px;
  }

  .solution-text {
    font-size: 12px;
    padding: 10px;
  }

  .detail-row {
    padding: 6px;
  }

  .detail-row i {
    font-size: 16px;
  }

  .detail-row label {
    font-size: 10px;
  }

  .detail-row p {
    font-size: 11px;
  }

  .details-btn {
    font-size: 11px;
    padding: 6px 10px;
  }
}
</style>
